import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { G_API } from '../constants/globalVar';
import { FaRegTimesCircle, FaSearch } from 'react-icons/fa';
import { COURSETYPES } from '../constants/courseTypes';

const SearchBar = ({ placeholder = "Search courses..." }) => {
    const [query, setQuery] = useState('');
    const [courseType, setCourseType] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const navigate = useNavigate();

    const resetSearch = () => {
        setQuery('');
        setCourseType('');
    }

    useEffect(() => {
        if (query.length < 2) {
            setSuggestions([]);
            return;
        }
        if (courseType) {
            setCourseType(courseType);
        }

        const course_type = courseType ?? '';
        const delayDebounce = setTimeout(() => {
        axios.post(G_API + 'courses/COURSE_LIST', {
                search: query,
                course_type: course_type
            })
            .then(res => {
                const data = res.data.DATAS || [];
                setSuggestions(data.slice(0, 5)); // Top 5 suggestions
            });
        }, 300);

        return () => clearTimeout(delayDebounce);
    }, [query, courseType]);

    return (
        <div className="d-flex justify-content-center mt-5 position-relative mb-5"
            style={{
                width: '1000px'
            }}
        >
        <div className="bg-primary-blue rounded-4 p-4 w-100">
            <h2 className="fs-2 text-white mb-3 text-center">Find a course</h2>

            <div className="row g-3 align-items-center w-full">
            <div className="col-md-4">
                <select className="form-control"
                    onChange={(e) => {
                        setCourseType(e.target.value);
                    }}
                >
                    <option value="">Select a course type</option>
                    {COURSETYPES.map(course_type => (
                        <option value={course_type.value} key={course_type.value}>{course_type.label}</option>
                    ))}
                </select>
            </div>
            <div className="col-md-8">
                <div className="input-group">
                    <input
                        type="text"
                        className="form-control"
                        placeholder={placeholder}
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                    />
                    <button className="btn bg-search" type="button">
                        { query.length > 0 ? (
                            <FaRegTimesCircle onClick={resetSearch} />
                        ) : (
                            <FaSearch onClick={() => navigate('/courses')} />
                        )}
                    </button>
                </div>
            </div>
            </div>

            {suggestions.length > 0 && (
            <ul className="list-group position-absolute mt-2 w-100" style={{ maxWidth: '900px', zIndex: 10 }}>
                {suggestions.map(course => (
                    <li
                        key={course.id}
                        className="list-group-item list-group-item-action"
                        onClick={() => navigate(`/courses/${course.slug || course.id}`)}
                        style={{ cursor: 'pointer' }}
                    >
                        {course.title}
                    </li>
                ))}
                <li
                    className="list-group-item list-group-item-secondary text-center"
                    onClick={() => navigate('/courses')}
                    style={{ cursor: 'pointer' }}
                >
                    See more results
                </li>
            </ul>
            )}
        </div>
        </div>
    );
};

export default SearchBar;
